import React from 'react'
import style from "./Title.module.css";

function Title({title}) {
  return (
    <div className={style.tit_wrapper}>
      <div className={style.tit_txt}>
          <p className={style.sub}>[{title}]</p>
          <p className={style.tit}>사건 진술서</p>
      </div>

      <div className={style.desc}>
        <p>- 예시를 참고하여, <span>시간 순서대로 육하원칙에 따라 작성</span>해주시기 바랍니다.</p>
        <p>- 해당 진술서는 담당변호사가 사실관계를 검토하여 의뢰인께 최선의 결과를 드리고자 사건을 진행하기 위한 자료입니다.</p>
      </div>
    </div>
  )
}

export default Title